import React, { useEffect, useState, useRef, useContext } from 'react';
import { Table, message, Space } from 'antd';
import Container from '@/components/container';
import FilterTag from '@/components/filter-tag';
import FilterForm from '../filter-form';
import Dongdong from '@/components/dongdong';
import { MANAGE_STATUS_TYPE_MAP, MANAGE_STATUS_TYPE_COLOR_MAP } from '../../data';
import apis from '../../apis';
import Copy from '@/components/copy';
import './index.less';
import Delete from '@/components/delete';
import DetailDrawer from '../detail-pop';
import AddErpUser from '@/components/add-erp-user';
import IconTip from '@/components/icon-tip';
import CheckFlow from '@/components/check-flow';
import { SearchOutlined, DownloadOutlined } from '@ant-design/icons';
import { STATUS2COLOR } from './constants';
import { getQuery, goto } from '@/common/utils';
import { Link } from 'react-router-dom';
import useTabSetting from '../../useTabSetting';

const MyManager = () => {
  useTabSetting(true);
  const [channelList, setChannelList] = useState([]);
  const [flowInfo, setFlowInfo] = useState({});
  const drawerRef = useRef(null);
  const manageRef = useRef(null);
  const channelIdQuery = getQuery('channelId');
  const [detailData, setDetailData] = useState({});

  const [data, setData] = useState({
    list: [],
    loading: false,
    totalCount: 0,
  });

  const [conditions, setConditions] = useState({
    keyword: channelIdQuery ? channelIdQuery : undefined,
    category: undefined,
    ownerErp: undefined,
    organizationName: undefined,
    createTimeBegin: undefined,
    createTimeEnd: undefined,
    status: 0,
    currentPage: 1,
    pageSize: 10,
  });

  const columns = [
    {
      align: 'left',
      title: '微频道名称/ID',
      width: 300,
      fixed: 'left',
      render: (data, record) => {
        return (
          <div>
            <a
              onClick={() => {
                getDetail(record.channelId);
                drawerRef.current.show();
              }}
            >
              {data.name}
            </a>
            <div>
              <Copy size="small" text={data.channelId}>
                微频道ID：{data.channelId}
              </Copy>
            </div>
          </div>
        );
      },
    },
    {
      align: 'left',
      title: '通天塔项目名称/ID',
      width: 200,
      render: (data) => {
        return (
          <div>
            <a
              onClick={() => {
                data.towerPageLink && goto(data.towerPageLink, 'newTab');
              }}
            >
              {data.towerName}
            </a>
            <div>
              <Copy size="small" text={data.towerId}>
                项目ID：{data.towerId}
              </Copy>
            </div>
          </div>
        );
      },
    },
    {
      align: 'left',
      title: '页面标题',
      width: 200,
      dataIndex: 'mainTitle',
      render: (data) => {
        return data ? data : '-';
      },
    },
    {
      align: 'left',
      title: '页面副标题',
      width: 200,
      dataIndex: 'lessTitle',
      render: (data) => {
        return data ? data : '-';
      },
    },
    {
      align: 'left',
      title: '组长',
      width: 140,
      render: (data, record) => {
        return <Dongdong name={record.ownerErp} erp={record.ownerErp} />;
      },
    },
    {
      align: 'left',
      title: '部门',
      width: 200,
      dataIndex: 'organizationName',
    },
    {
      align: 'left',
      title: (
        <>
          状态
          <IconTip title="微频道需要先入驻再上场，入驻审核通过后，由上场审核组成员审核上场。" />
        </>
      ),
      width: 140,
      dataIndex: 'status',
      key: 'status',
      fixed: 'right',
      render: (data, record) => {
        return (
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <div
              className="channel-micro-my-approve-point"
              style={{ background: MANAGE_STATUS_TYPE_COLOR_MAP[data] }}
            ></div>
            <span>
              {MANAGE_STATUS_TYPE_MAP[data]}
              {(record.status === 2 || record.status === 3 || record.status === 5 || record.status === 6) && (
                <CheckFlow
                  placement="top"
                  flowArr={flowInfo[record.channelId]}
                  fieldNames={{ title: 'nodeName', time: 'createTime', content: 'reason' }}
                >
                  <SearchOutlined
                    style={{ fontSize: '14px', marginLeft: '6px', cursor: 'pointer' }}
                    onMouseEnter={() => {
                      getCheckFlowInfo(record.channelId);
                    }}
                  />
                </CheckFlow>
              )}
            </span>
          </div>
        );
      },
    },
    {
      align: 'left',
      title: '操作',
      width: 300,
      fixed: 'right',
      render: (data, record) => {
        return (
          <div style={{ display: 'flex' }}>
            <Space size={12}>{renderBtn(data, record)}</Space>
          </div>
        );
      },
    },
  ];

  useEffect(() => {
    if (!channelIdQuery) return;
    getDetail(channelIdQuery);
    drawerRef.current.show();
  }, [channelIdQuery]);

  function getCount() {
    apis.channelMicroStatusCount({ type: 2 }).then((res) => {
      const {
        ret,
        data: { reject = 0, submit = 0, inApprove = 0, toOnline = 0, online = 0, offline = 0 },
      } = res;
      if (ret === '0') {
        const tagInfo = [
          {
            id: 0,
            value: '全部',
          },
          {
            id: 1,
            value: '被驳回(' + reject + ')',
          },
          {
            id: 2,
            value: '待提交(' + submit + ')',
          },
          {
            id: 3,
            value: '审核中(' + inApprove + ')',
          },
          {
            id: 4,
            value: '待上场(' + toOnline + ')',
          },
          {
            id: 5,
            value: '已上线(' + online + ')',
          },
          {
            id: 6,
            value: '已下线(' + offline + ')',
          },
        ];
        setChannelList(tagInfo);
      }
    });
  }

  useEffect(() => {
    getCount();
  }, []);

  useEffect(() => {
    apis.channelMicroMyManager({ ...conditions }).then((res) => {
      const { ret, data } = res;
      if (ret === '0') {
        setData(Object.assign([], data));
      }
    });
  }, [conditions]);

  function getCheckFlowInfo(channelId) {
    apis.channelMicroApprovalFlow({ channelId }).then((res) => {
      const { ret, data } = res;
      if (ret === '0' && data) {
        const flowIn = Object.assign({}, flowInfo);
        flowIn[channelId] = res.data.list;
        flowIn[channelId].forEach((item) => {
          item.color = STATUS2COLOR.get(item.status);
        });
        setFlowInfo(flowIn);
      }
    });
  }

  function renderBtn(data, record) {
    return data.button?.map((item, index) => {
      switch (item) {
        case 'submit': {
          return (
            <Delete
              title="确认提交吗？"
              key={index}
              onConfirm={() => channelMicroStatusEvent({ channelId: record.channelId, operate: 1 })}
            >
              <a>提交</a>
            </Delete>
          );
        }
        case 'update': {
          return (
            <Link key={index} to={`/channel-micro/edit-channel?channelId=${record.channelId}`}>
              编辑
            </Link>
          );
        }
        case 'detail': {
          return (
            <a
              key={index}
              onClick={() => {
                getDetail(record.channelId);
                drawerRef.current.show();
              }}
            >
              查看详情
            </a>
          );
        }
        case 'member': {
          return (
            <a
              key={index}
              onClick={() => {
                addErpUser(record.channelId);
              }}
            >
              管理组设置
            </a>
          );
        }
        case 'offline': {
          return (
            <Delete
              key={index}
              title="下线后微频道将不能在前台流量场露出"
              onConfirm={() => channelMicroStatusEvent({ channelId: record.channelId, operate: 4 })}
            >
              <a>下线</a>
            </Delete>
          );
        }
      }
    });
  }

  const channelMicroStatusEvent = (param) => {
    apis.channelMicroStatusEvent({ ...param }).then((res) => {
      const { ret, msg } = res;
      if (ret === '0') {
        message.success('操作成功');
        setConditions({ ...conditions, currentPage: 1, pageSize: 10 });
        setTimeout(() => {
          getCount();
        }, 500);
      } else {
        message.error(msg);
      }
    });
  };

  const updateParam = (param) => {
    setConditions({ ...conditions, ...param });
  };

  function addErpUser(channelId) {
    manageRef.current.open({
      type: 'list',
      title: (
        <>
          微频道管理组设置
          <span style={{ fontSize: '14px', fontWeight: 'normal' }}>
            &nbsp;管理组权限
            <IconTip title="用于微频道的查询、下线管理等权限控制" type="question" />
          </span>
        </>
      ),
      onDeleteItem: (item, onDeleteSuccess) => {
        apis
          .channelMicroDelMember({ erp: item.erp, channelId, roleCode: 'manager' })
          .then((res) => {
            if (res.ret === '0') onDeleteSuccess();
            else message.error(res.msg || '网络异常请稍后');
          })
          .catch((ex) => {
            message.error('网络异常请稍后');
          });
      },
      onOk: async (nowformData, successCallBack) => {
        const list = nowformData.erps;
        const { ret, msg, data } =
          (await apis.channelMicroAddMember({ channelId, erps: list, roleCode: 'manager' })) || {};
        if (ret === '0') {
          // message.success('上传成功！');
          successCallBack({ success: data.success, failure: data.failure, reasons: data.reasons });
        } else {
          message.error(msg || '上传失败');
        }
      },
      onTranslateOwner: (item, refresh) => {
        return apis
          .channelMicroChangeOwner({ channelId, erp: item.erp, roleCode: item.roleCode })
          .then((res) => {
            if (res && res.ret === '0') {
              refresh();
              message.success('权限转移成功');
            }
          })
          .catch((ex) => {
            message.error('网络异常请稍后');
          });
      },
      fetchErpList: () => {
        return apis.channelMicroMemberList({ channelId }).then((res) => {
          if (res && res.ret === '0' && res.data?.list) {
            return res.data.list.map((item) => {
              // 如果没有权限就直接返回
              if (item.isOwner) return { ...item, erpRealName: item.realName, canDelete: false };
              return { ...item, erpRealName: item.realName, canDelete: true };
            });
          }
          throw new Error(res.msg);
        });
      },
    });
  }

  function download() {
    apis.channelMicroMyManagerExport({ ...conditions }).then((res) => {
      const { ret, msg } = res;
      if (ret === '0') {
        message.success('下载完成后将通过邮件发送，请稍后查询邮件');
      } else {
        message.error(msg);
      }
    });
  }

  function getDetail(channelId) {
    if (!channelId) return;
    apis.channelMicroGetChannel({ channelId }).then((res) => {
      const { ret, data, msg } = res;
      if (ret === '0') {
        setDetailData(data);
      } else {
        message.error(msg);
      }
    });
  }

  return (
    <Container margin={{ vertical: true }}>
      {channelList.length > 0 && (
        <div style={{ display: 'flex', marginBottom: '16px' }}>
          微频道状态：
          <FilterTag.Group
            defaultValue={0}
            onChange={(value) => {
              setConditions({ ...conditions, status: value, currentPage: 1, pageSize: 10 });
            }}
          >
            {channelList.map((item) => {
              return (
                <FilterTag value={item.id} key={item.id}>
                  {item.value}
                </FilterTag>
              );
            })}
          </FilterTag.Group>
        </div>
      )}
      <FilterForm updateParam={updateParam} />
      <div className="channel-micro-download">
        <div onClick={download} className="channel-micro-download-btn">
          <DownloadOutlined style={{ marginRight: '5px', marginLeft: '20px' }} />
          下载表格
        </div>
      </div>
      <div style={{ marginTop: '24px' }}>
        <Table
          rowKey="channelId"
          scroll={{ x: 1300 }}
          columns={columns}
          loading={data.loading}
          dataSource={data.list}
          pagination={{
            current: conditions.currentPage,
            total: data.totalCount,
            pageSize: conditions.pageSize,
            onChange: (toPage, pageSize) => {
              setConditions({
                ...conditions,
                currentPage: toPage,
                pageSize: pageSize,
              });
            },
          }}
        />
      </div>
      <DetailDrawer ref={drawerRef} data={detailData} />
      <AddErpUser ref={manageRef} />
    </Container>
  );
};
export default MyManager;
